import './App.css';

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import MainPage from "./components/pages/Main/MainPage"
import Catalog from "./components/pages/CatalogPage/Catalog"
import ReviewsPage from './components/pages/ReviewsPage/ReviewsPage'
import ContactsPage from './components/pages/ContactStorage/Contact'
import NewsPage from './components/pages/NewsPage/NewsPage'
import ProfilePage from './components/pages/ProfilePage/ProfilePage'

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/catalog" element={<Catalog />} />
        <Route path="/reviews" element={<ReviewsPage />} />
        <Route path="/contact" element={<ContactsPage />} />
        <Route path="/news" element={<NewsPage />} />
        <Route path="/profile" element={<ProfilePage />} />
      </Routes>
    </Router>
  );
}


export default App;
